export default "__VITE_ASSET__vMK$Uh2S__"